













import DemoFile from '../../classes/Main/DemoFile'
import { ListCursor } from './ListCursor'
import BookComponentListItem from './BookComponentListItem.vue'

export default {
  components: {
    BookComponentListItem,
  },
  props: {
    listCursor: {
      type: ListCursor,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
  },
  methods: {
    filePreSelected (file: DemoFile): boolean {
      return this.listCursor.preSelectedItem === file
    },
  },
}
